<template>
  <div>
    <a-modal
      :width="this.settings['isMobileView'] ? 420 : this.settings['isTabletView'] ? 600 : 840"
      v-model="visible"
      title="Add / Update Remarks"
      onOk="handleSubmit"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Save Remarks</a-button>
      </template>
      <a-spin :spinning="spinning">
        <p class="text-muted mb-4">Enter remarks for each student.</p>
        <a-form class="mb-4" :form="form">
          <div class="row neo-exam-remark-form-table-container" v-if="examData">
            <div class="col-12 col-md-12 col-lg-12">
              <table class="table table-bordered w-100">
                <thead>
                  <th style="width: 6%;">Sl. No.</th>
                  <th style="width: 15%;">Stud. Code</th>
                  <th style="width: 10%;">Roll No.</th>
                  <th style="width: 30%;">Name</th>
                  <th>Remarks</th>
                </thead>
                <tbody>
                  <tr v-for="(student_enrollment, index) in studentsData" :key="student_enrollment.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ student_enrollment.student_code }}</td>
                    <td>{{ student_enrollment.roll_no }}</td>
                    <td>{{ student_enrollment.student.first_name }} {{ student_enrollment.student.last_name }}</td>
                    <td>
                      <a-form-item class="m-0">
                        <a-input
                          placeholder="Enter remark"
                          v-decorator="[`remarks[${student_enrollment.id}]`, { initialValue: getInitialRemark(student_enrollment) }]"
                        />
                      </a-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ClassExamRemarksForm',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      examData: null,
      studentsData: [],
    }
  },
  mounted() {
    this.$eventBus.$on('openClassExamRemarksForm', this.showModal)
  },
  beforeDestroy() {
    this.$eventBus.$off('openClassExamRemarksForm', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    showModal(examData, studentsData) {
      this.visible = true
      this.examData = examData
      this.studentsData = studentsData
    },
    getInitialRemark(enrollment) {
      if (enrollment.student_exam_remark && enrollment.student_exam_remark.length > 0) {
        return enrollment.student_exam_remark[0].exam_remark || ''
      }
      return ''
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: 'Are you sure?',
            content: 'Do you want to save these remarks?',
            onOk: () => {
              this.loading = true
              const studentRemarks = []

              Object.keys(values.remarks).forEach(enrollmentId => {
                const enrollmentIdVal = parseInt(enrollmentId)
                const examRemarkVal = values.remarks[enrollmentId]

                // Find the student to check original remark
                const student = this.studentsData.find(s => s.id === enrollmentIdVal)
                const originalRemark = this.getInitialRemark(student)

                // Only send if remark has changed and is not empty (backend validation requirement)
                if (examRemarkVal !== originalRemark && examRemarkVal && examRemarkVal.trim() !== '') {
                  studentRemarks.push({
                    enrollment_id: enrollmentIdVal,
                    exam_remark: examRemarkVal.trim(),
                  })
                }
              })

              const payload = {
                class_section_exam_id: this.examData.id,
                student_remarks: studentRemarks,
              }

              this.$http
                .post('/api/studentexamremark/save', payload)
                .then(() => {
                  this.$emit('updated')
                  this.loading = false
                  this.visible = false
                  this.$notification.success({
                    message: 'Successfully updated',
                    description: 'Remarks updated successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
